import styles from './MoreAccessories.scss';

import React from 'react';
import { useTranslation } from 'react-i18next';

import { useCart } from 'src/components/Cart/UseCart';
import { TextV2 } from 'src/components/TextV2/TextV2';
import { AccessoryItem } from './AccessoryItem';

export const MoreAccessories: React.FC = () => {
  const { t } = useTranslation();
  const { cart } = useCart();

  if (cart.upsell.length < 1) {
    return null;
  }

  const upsellItems = cart?.upsell?.sort((productA, productB) => {
    return productB.totalCost - productA.totalCost;
  });

  return (
    <div className={styles.moreAccessories}>
      <TextV2
        tagName="h2"
        variant="h4"
        value={t('expand-your-system.heading')}
        data-test="heading"
      />

      <div className={styles.moreAccessoriesBox}>
        {upsellItems?.map(product => <AccessoryItem key={product.id} product={product} />)}
      </div>
    </div>
  );
};

MoreAccessories.displayName = 'MoreAccessories';
